import { cn } from '../../lib/utils';

/**
 * "Workf" + handwritten orange "l" + "ow" — mirrors the Planverse wordmark treatment.
 */
export default function WorkflowLogo({
  className,
  size = 22,
}: {
  className?: string;
  size?: number;
}) {
  return (
    <p
      className={cn(
        'font-wordmark font-semibold leading-none text-foreground whitespace-nowrap',
        className,
      )}
      style={{ fontSize: `${size}px` }}
      aria-label="Workflow"
    >
      Workf
      <span
        className="font-hand font-normal text-primary"
        style={{ fontSize: `${size * 1.15}px`, verticalAlign: '-0.05em' }}
        aria-hidden
      >
        l
      </span>
      ow
    </p>
  );
}
